import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.18 8.626h-6.407a.38.38 0 0 1-.377-.377V1.842a1.885 1.885 0 0 0-3.77 0v6.407a.377.377 0 0 1-.376.377H1.842a1.885 1.885 0 0 0 0 3.769h6.407a.377.377 0 0 1 .377.377v6.408a1.885 1.885 0 1 0 3.769 0v-6.407a.376.376 0 0 1 .377-.377h6.408a1.885 1.885 0 1 0 0-3.77"
    }, null, -1)
  ]))]))
}
export default { render: render }